import { PROFILE_PIC_URL } from "./pathConstants"
import { INSTRUCTOR_GENDERS } from "./searchConstants"

export enum INSTRUCTOR_AWARD_ICON_URLS {
	QUICK_REPLY_BRONZE = '/imgs/icons/awards/icon-awards-quick-replies-bronze.svg',
	QUICK_REPLY_SILVER = '/imgs/icons/awards/icon-awards-quick-replies-silver.svg',
	QUICK_REPLY_GOLD = '/imgs/icons/awards/icon-awards-quick-replies-gold.svg',
	TOP_RATED_BRONZE = '/imgs/icons/awards/icon-awards-top-rated-bronze.svg',
	TOP_RATED_SILVER = '/imgs/icons/awards/icon-awards-top-rated-silver.svg',
	TOP_RATED_GOLD = '/imgs/icons/awards/icon-awards-top-rated-gold.svg',
	EXPERIENCED_BRONZE = '/imgs/icons/awards/icon-awards-experienced-bronze.svg',
	EXPERIENCED_SILVER = '/imgs/icons/awards/icon-awards-experienced-silver.svg',
	EXPERIENCED_GOLD = '/imgs/icons/awards/icon-awards-experienced-gold.svg',
	PERSONALIZED = '/imgs/icons/awards/icon-awards-personalized.svg'
}

export enum INSTRUCTOR_AWARD_TITLES {
	QUICK_REPLY_BRONZE = 'Quick Replies',
	QUICK_REPLY_SILVER = 'Quick Replies',
	QUICK_REPLY_GOLD = 'Quick Replies',
	TOP_RATED_BRONZE = 'Top Rated',
	TOP_RATED_SILVER = 'Top Rated',
	TOP_RATED_GOLD = 'Top Rated',
	EXPERIENCED_BRONZE = 'Experienced',
	EXPERIENCED_SILVER = 'Experienced',
	EXPERIENCED_GOLD = 'Experienced',
	PERSONALIZED = 'Personalized'
}

export enum INSTRUCTOR_AWARD_DESCRIPTIONS {
	QUICK_REPLY_BRONZE = 'This instructor has received 10 five-star Quick Reply reviews.',
	QUICK_REPLY_SILVER = 'This instructor has received 25 five-star Quick Reply reviews.',
	QUICK_REPLY_GOLD = 'This instructor has received 50 five-star Quick Reply reviews.',
	TOP_RATED_BRONZE = 'This instructor has received 10 five-star reviews.',
	TOP_RATED_SILVER = 'This instructor has received 25 five-star reviews.',
	TOP_RATED_GOLD = 'This instructor has received 50 five-star reviews.',
	EXPERIENCED_BRONZE = 'This instructor has completed 10 sessions on SkiVio',
	EXPERIENCED_SILVER = 'This instructor has completed 25 sessions on SkiVio',
	EXPERIENCED_GOLD = 'This instructor has completed 50 sessions on SkiVio',
	PERSONALIZED = 'This instructor has completed 10 sessions on SkiVio'
}

/**
 * get url path to the profile pic from the give sting and desired index
 * @param picStr comma seperated string of file names which should be located in the profile pic folder
 * @param index desired index from the picStr array
 */
export function getProfilePicPath(picStr: string, index: number): string {
	return `${PROFILE_PIC_URL}${picStr.split(',')[index]}`
}

export function getProfilePicCount(picStr: string): number {
	return picStr.split(',').length
}

export function getSmallProfilePicPath(picStr: string, index: number): string {
	return `${PROFILE_PIC_URL}small_${picStr.split(',')[index]}`
}

export function getProfilePicPathArr(picStr: string): string[] {
	return picStr.split(',').map((fileName: string) => `${PROFILE_PIC_URL}${fileName}`)
}

export const defaultProfilePicFileName: string = 'user-icon.svg'

export function getGenderStringFromIndex(genderIndex: number): string {
	return INSTRUCTOR_GENDERS[genderIndex] ? INSTRUCTOR_GENDERS[genderIndex] : ''
}